import React from "react";
import { useHistory } from "react-router-dom";
import {
	HomeButton,
	NotFoundImage,
	NotFoundSubTitle,
	NotFoundTitle,
	NotFoundWrapper,
} from "./style";

export function NotFound() {
	const history = useHistory();

	return (
		<NotFoundWrapper>
			<NotFoundImage
				src="https://www.kakaocorp.com/page/img_error.png"
				alt="not found"
			/>

			<NotFoundTitle>찾으시는 페이지가 없습니다.</NotFoundTitle>
			<NotFoundSubTitle>
				잘못된 접근이거나 요청하신 페이지를 찾을 수 없습니다.
				<br />
				입력하신 페이지의 주소가 정확한지 다시 한번 확인해 주시기 바랍니다.
			</NotFoundSubTitle>

			<HomeButton variant="contained" onClick={() => history.push("/")}>
				홈으로
			</HomeButton>
		</NotFoundWrapper>
	);
}
